"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelImage = _interopRequireDefault(require("./BrixelImage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelAvatar = props => {
  const {
    avatarImg = null,
    className = '',
    isIcon = false,
    name = null,
    onClick = () => '',
    profileId = '',
    size = 'XXS'
  } = props;
  // FUNCTIONS TO CREATE THE AVATAR IMAGE FROM LOGGED USER NAME
  const extractName = () => {
    const splitName = name ? name.split(' ') : null;
    if (splitName) {
      if (splitName.length > 1) return `${splitName[0].charAt(0).toUpperCase()}${splitName[1].charAt(0).toUpperCase()}`;
      return `${splitName[0].charAt(0).toUpperCase()}${splitName[0].charAt(1).toUpperCase()}`;
    }
    return '';
  };
  const sizeXY = () => {
    let defaultSize = '';
    if (size === 'XXS' || !size && isIcon) {
      defaultSize = '32';
    } else if (size === 'L') {
      defaultSize = '56';
    } else if (size === 'S') {
      defaultSize = '48';
    } else if (size === 'M' || avatarImg && !size || !avatarImg && !size) {
      defaultSize = '40';
    }
    return defaultSize;
  };
  // Generate avatar color by user name
  const stringToHslColor = (str, s, l) => {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      hash = str.charCodeAt(i) - hash;
    }
    const h = hash % 360;
    return `hsl(${h}, ${s}%, ${l}%)`;
  };
  const imgClasses = () => {
    let imgClass = '';
    if (typeof onClick === 'function') {
      imgClass += 'cur-poi';
    }
    if (avatarImg) {
      imgClass += 'avatarImg';
    }
    return imgClass;
  };
  const AvatarColor = () => {
    if (isIcon) return '';
    if (profileId) return stringToHslColor(profileId, 50, 60);
    return '#5A6EFF';
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, avatarImg && (/*#__PURE__*/_react.default.createElement(_BrixelImage.default, {
    isSquare: true,
    url: avatarImg,
    alt: `Profile ${name}`,
    size: size,
    className: `notranslate brdCircle brixelAvatar ${className} ${imgClasses()} w-fix-${sizeXY()} h-fix-${sizeXY()}`,
    onClick: onClick ? val => onClick(val) : undefined
  })), !avatarImg && (/*#__PURE__*/_react.default.createElement("div", {
    className: `brixelAvatar defaultAvt ${className} flex-${sizeXY()} w-fix-${sizeXY()} h-fix-${sizeXY()} ${isIcon ? 'withIcon' : ''} notranslate`,
    onClick: val => typeof onClick === 'function' ? onClick(val) : '',
    style: {
      backgroundColor: AvatarColor() || ''
    }
  }, isIcon ? (/*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
    width: sizeXY(),
    height: sizeXY(),
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#009579"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: sizeXY(),
    height: sizeXY()
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#009579"
  })), /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".4",
    fill: "#fff",
    mask: "url(#a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 8c-3.196 0-5.786 2.66-5.786 5.943 0 3.282 2.59 5.944 5.786 5.944 3.194 0 5.786-2.66 5.786-5.944C21.784 10.66 19.194 8 16 8zM7 31.6V43h18V31.6c0-5.008-4.03-9.072-9.001-9.072C11.029 22.531 7 26.592 7 31.6z"
  }))))) : (/*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-400 fweight-500"
  }, " ", extractName(), " ")))));
};
var _default = exports.default = BrixelAvatar;